// Risk & position-sizing calculator — pure client-side, no API calls.
// All amounts in EUR; works for crypto, FX, or any single-leg trade.

export function calcular(i) {
  const safeNum = (v, d = 0) => (Number.isFinite(+v) ? +v : d);

  const capital = Math.max(safeNum(i.capital), 0);
  const riesgoPorc = Math.max(safeNum(i.riesgoPorc, 1), 0.1);
  const entrada = Math.max(safeNum(i.entrada), 0.0000001);
  const stopLoss = Math.max(safeNum(i.stopLoss), 0.0000001);
  const objetivo = Math.max(safeNum(i.objetivo), 0.0000001);
  const apalancamiento = Math.max(safeNum(i.apalancamiento, 1), 1);
  const direccion = i.direccion === "short" ? "short" : "long";

  const riesgoEuros = capital * (riesgoPorc / 100);
  const diffStop = Math.abs(entrada - stopLoss) || 0.0000001;
  const diffObjetivo = Math.abs(objetivo - entrada);
  const porcentajeStop = (diffStop / entrada) * 100;
  const porcentajeObj = (diffObjetivo / entrada) * 100;
  const ratioRR = diffObjetivo / diffStop;
  const tamanoPosicion = (riesgoEuros / (diffStop / entrada)) * (1 / apalancamiento);
  const cantidadMonedas = entrada > 0 ? tamanoPosicion / entrada : 0;
  const gananciaEuros = riesgoEuros * ratioRR;

  const margen = 1 / apalancamiento;
  const precioLiq =
    direccion === "long"
      ? entrada * (1 - margen * 0.9)
      : entrada * (1 + margen * 0.9);

  const mensajes = [];
  let calificacion = "bueno";

  if (ratioRR >= 3) {
    calificacion = "excelente";
    mensajes.push("✅ Excelente ratio R:R — setup de alta calidad");
  } else if (ratioRR >= 2) {
    calificacion = "bueno";
    mensajes.push("✅ Buen ratio R:R — setup aceptable");
  } else if (ratioRR >= 1.5) {
    calificacion = "aceptable";
    mensajes.push("⚠️ Ratio R:R justo — busca un mejor entry o mueve el objetivo");
  } else {
    calificacion = "malo";
    mensajes.push("❌ Ratio R:R insuficiente — este setup no compensa el riesgo");
  }

  if (riesgoPorc > 2) mensajes.push("⚠️ Arriesgas más del 2% — considera reducir para proteger el capital");
  if (riesgoPorc > 3) {
    mensajes.push("🚨 Riesgo muy elevado — los prop traders profesionales usan máximo 1-2% por trade");
    if (calificacion !== "malo") calificacion = "peligroso";
  }
  if (apalancamiento > 20) {
    mensajes.push("🚨 Apalancamiento extremo — un 5% en tu contra liquida la posición");
    calificacion = "peligroso";
  } else if (apalancamiento > 10) {
    mensajes.push("⚠️ Alto apalancamiento — la volatilidad cripto puede liquidarte rápidamente");
  }
  if (porcentajeStop < 1) mensajes.push("⚠️ Stop muy ajustado — el ruido del mercado puede sacarte antes de tiempo");
  if (ratioRR >= 2 && riesgoPorc <= 1) mensajes.push("🌟 Setup profesional — riesgo controlado con buen potencial");

  return {
    riesgoEuros: Math.round(riesgoEuros * 100) / 100,
    gananciaEuros: Math.round(gananciaEuros * 100) / 100,
    ratioRR: Math.round(ratioRR * 100) / 100,
    tamanoPosicion: Math.round(tamanoPosicion * 100) / 100,
    cantidadMonedas: Math.round(cantidadMonedas * 10000) / 10000,
    porcentajeStop: Math.round(porcentajeStop * 100) / 100,
    porcentajeObjetivo: Math.round(porcentajeObj * 100) / 100,
    precioLiquidacion: Math.round(precioLiq * 100) / 100,
    calificacion,
    mensajes,
  };
}

export const CALIFICACION_COLOR = {
  excelente: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  bueno: "border-cyan-400/40 bg-cyan-400/[0.08] text-cyan-200",
  aceptable: "border-amber-400/40 bg-amber-400/[0.08] text-amber-200",
  malo: "border-red-400/40 bg-red-400/[0.08] text-red-200",
  peligroso: "border-red-500/60 bg-red-500/[0.15] text-red-100 animate-pulse",
};
